const state = {
    // 当前路由信息
    currentRoute: {
        path: '/user/user-center',
        name: 'user-center',
        title: '个人中心',
        meta: {}
    },
    // 路由历史记录
    routeHistory: [],
    // 标签页列表
    tabs: [],
    // 当前激活的标签
    activeTab: '/',
    // 当前激活标签的显示名称（导航栏名称/标题）
    activeTabTitle: '个人中心',
    // 路由权限映射
    routePermissions: {
        // 用户中心及其子页面
        '/user/index': {
            title: '用户中心',
            children: {
                '/user/user-center': {title: '个人中心', children: {}},
                '/user/purchase/post': {title: '询单管理', children: {}},
                '/user/purchase/order': {title: '成交订单', children: {}},
                '/user/purchase/release': {title: '发布询单', children: {}},
                '/user/supplier/my-project': {title: '我的产品', children: {}},
                '/user/supplier/quotation': {title: '报价管理', children: {}},
                '/user/supplier/sale-order': {title: '销售订单', children: {}},
                '/user/technology': {title: '技术供需管理', children: {}},
                '/user/process': {title: '加工供需管理', children: {}},
                '/user/message/message-counter': {title: '推送设置', children: {}},
                '/user/message/mail': {title: '站内信', children: {}},
                '/user/message/complaint': {title: '投诉建议', children: {}},
                '/user/base-info': {title: '基本资料', children: {}}
            }
        }
    }
}

const mutations = {
    // 设置当前路由
    SET_CURRENT_ROUTE(state, route) {
        state.currentRoute = route
    },

    // 添加路由历史
    ADD_ROUTE_HISTORY(state, route) {
        // 避免重复添加相同的路由
        const exists = state.routeHistory.find(item => item.path === route.path)
        if (!exists) {
            state.routeHistory.push(route)
        }
    },

    // 设置标签页列表
    SET_TABS(state, tabs) {
        state.tabs = tabs
    },

    // 添加标签页
    ADD_TAB(state, tab) {
        // 排除非用户中心路由和用户中心根路由
        if (!tab.path.includes('user') || tab.path === '/user/index') return;

        // 检查是否已存在相同路径的标签页
        const exists = state.tabs.find(item => item.path === tab.path);
        if (!exists) {
            // 确保标签页有完整的信息
            const newTab = {
                path: tab.path,
                name: tab.name || tab.path.split('/').pop(),
                title: tab.title || tab.meta?.title || '未知页面',
                meta: tab.meta || {}
            };
            state.tabs.push(newTab);
        }
    },

    // 移除标签页
    REMOVE_TAB(state, path) {
        state.tabs = state.tabs.filter(tab => tab.path !== path)
    },

    // 设置当前激活的标签
    SET_ACTIVE_TAB(state, path) {
        state.activeTab = path
    },

    // 设置当前激活标签的标题
    SET_ACTIVE_TAB_TITLE(state, title) {
        state.activeTabTitle = title
    },

    // 清空路由历史
    CLEAR_ROUTE_HISTORY(state) {
        state.routeHistory = []
    }
}

const actions = {
    // 导航到指定路由
    navigateTo({commit, dispatch}, {path, name, title, meta = {}}) {
        const route = {path, name, title, meta}

        // 更新当前路由
        commit('SET_CURRENT_ROUTE', route)

        // 添加到路由历史
        commit('ADD_ROUTE_HISTORY', route)

        // 添加到标签页
        commit('ADD_TAB', route)

        // 设置当前激活的标签
        commit('SET_ACTIVE_TAB', path)
        // 设置当前激活标签标题
        commit('SET_ACTIVE_TAB_TITLE', title)

        // 执行路由跳转
        dispatch('performNavigation', path)
    },

    // 执行路由跳转
    performNavigation({state}, path) {
        // 只处理用户中心相关的路由
        if (path.startsWith('/user/')) {
            // 使用 Vue Router 进行跳转
            if (window.$router) {
                window.$router.push(path).catch(err => {
                    if (err.name !== 'NavigationDuplicated') {
                        throw err
                    }
                })
            }
        }
    },

    // 关闭标签页
    closeTab({commit, state, dispatch}, path) {
        // 如果试图关闭首页标签，直接返回
        if (path === '/user/user-center') {
            return;
        }

        const closingCurrentTab = path === state.activeTab;
        const tabIndex = state.tabs.findIndex(tab => tab.path === path);

        // 移除标签页
        commit('REMOVE_TAB', path);

        // 如果关闭的是当前激活的标签页，需要切换到其他标签页
        if (closingCurrentTab && state.tabs.length > 0) {
            let targetTab;

            // 优先选择关闭标签页右侧的标签页，如果没有则选择左侧的
            if (tabIndex >= 0) {
                if (tabIndex < state.tabs.length) {
                    // 选择右侧标签页
                    targetTab = state.tabs[tabIndex];
                } else if (tabIndex > 0) {
                    // 选择左侧标签页
                    targetTab = state.tabs[tabIndex - 1];
                } else {
                    // 选择第一个标签页
                    targetTab = state.tabs[0];
                }
            } else {
                // 默认选择第一个标签页
                targetTab = state.tabs[0];
            }

            if (targetTab) {
                commit('SET_ACTIVE_TAB', targetTab.path);
                commit('SET_ACTIVE_TAB_TITLE', targetTab.title);
                dispatch('performNavigation', targetTab.path);
            }
        }
    },

    // 切换到指定标签页
    switchTab({commit, dispatch, state}, path) {
        commit('SET_ACTIVE_TAB', path)
        // 同步标题
        const target = state.tabs.find(t => t.path === path)
        if (target) {
            commit('SET_ACTIVE_TAB_TITLE', target.title)
        }
        dispatch('performNavigation', path)
    },

    // 获取路由的子页面
    getChildRoutes({state}, parentPath) {
        const routeInfo = state.routePermissions[parentPath]
        if (routeInfo && routeInfo.children) {
            return Object.keys(routeInfo.children).map(path => ({
                path,
                title: routeInfo.children[path].title,
                children: routeInfo.children[path].children
            }))
        }
        return []
    },

    // 检查路由权限
    checkRoutePermission({state}, path) {
        // 只检查用户中心相关的路由权限
        if (path.startsWith('/user/')) {
            // 这里可以根据用户角色和权限进行判断
            // 例如：检查用户是否登录、是否有访问特定页面的权限等
            return true
        }
        // 非用户中心路由不进行权限检查
        return true
    },
    // 初始化路由状态
    initRouterState({commit, dispatch}, router) {
        // 保存 router 实例到全局
        window.$router = router
        // 监听路由变化
        router.beforeEach((to, from, next) => {
            // 检查路由权限
            dispatch('checkRoutePermission', to.path).then(hasPermission => {
                if (hasPermission) {
                    // 更新当前路由信息
                    commit('SET_CURRENT_ROUTE', {
                        path: to.path,
                        name: to.name,
                        title: to.meta?.title || to.name,
                        meta: to.meta || {}
                    })
                    // 添加到标签页
                    commit('ADD_TAB', {
                        path: to.path,
                        name: to.name,
                        title: to.meta?.title || to.name,
                        meta: to.meta || {}
                    })
                    // 设置当前激活的标签
                    commit('SET_ACTIVE_TAB', to.path)
                    commit('SET_ACTIVE_TAB_TITLE', to.meta?.title || to.name)
                    next()
                } else {
                    // 没有权限，跳转到登录页或错误页
                    next('/login')
                }
            })
        })
    }
}

const getters = {
    // 获取当前路由信息
    currentRoute: state => state.currentRoute,

    // 获取路由历史
    routeHistory: state => state.routeHistory,

    // 获取标签页列表
    tabs: state => state.tabs,

    // 获取当前激活的标签
    activeTab: state => state.activeTab,
    // 获取当前激活标签的标题
    activeTabTitle: state => state.activeTabTitle,

    // 获取路由权限映射
    routePermissions: state => state.routePermissions,

    // 获取指定路由的子页面
    getChildRoutes: (state) => (parentPath) => {
        const routeInfo = state.routePermissions[parentPath]
        if (routeInfo && routeInfo.children) {
            return Object.keys(routeInfo.children).map(path => ({
                path,
                title: routeInfo.children[path].title,
                children: routeInfo.children[path].children
            }))
        }
        return []
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
